<template>
  <section>
    <page-header :title="title">
      <template v-slot:headerContent>
        <div class="header-link-container">
          <a :href="historyLink" class="button header-link-button"
            >View History
          </a>
          <span v-if="historyLoaded && referralsCount" class="badge">{{
            referralsCount
          }}</span>
        </div>
      </template>
    </page-header>
    <p>{{ description }}</p>
    <section class="referral-cards" v-if="referralProgramInfo">
      <div v-if="referralPopularData" class="dbc-card referral-card popular">
        <div class="referral-card-header">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM8.5 9.5C8.5 9.04037 8.59053 8.58525 8.76642 8.16061C8.94231 7.73597 9.20012 7.35013 9.52513 7.02513C9.85013 6.70012 10.236 6.44231 10.6606 6.26642C11.0852 6.09053 11.5404 6 12 6C12.4596 6 12.9148 6.09053 13.3394 6.26642C13.764 6.44231 14.1499 6.70012 14.4749 7.02513C14.7999 7.35013 15.0577 7.73597 15.2336 8.16061C15.4095 8.58525 15.5 9.04037 15.5 9.5C15.5 10.4283 15.1313 11.3185 14.4749 11.9749C13.8185 12.6313 12.9283 13 12 13C11.0717 13 10.1815 12.6313 9.52513 11.9749C8.86875 11.3185 8.5 10.4283 8.5 9.5ZM18.258 16.984C17.5092 17.9253 16.5575 18.6855 15.4739 19.2077C14.3904 19.7299 13.2029 20.0008 12 20C10.7971 20.0008 9.60965 19.7299 8.52607 19.2077C7.44249 18.6855 6.49081 17.9253 5.742 16.984C7.363 15.821 9.575 15 12 15C14.425 15 16.637 15.821 18.258 16.984Z"
              fill="#125ECE"
            />
          </svg>
          <span class="referral-type">
            Individual Referral
          </span>

          <div class="referral-card-label">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_49709_2712)">
                <path
                  d="M7.68323 1.53058C7.71245 1.47155 7.75758 1.42187 7.81353 1.38713C7.86949 1.35239 7.93404 1.33398 7.9999 1.33398C8.06576 1.33398 8.13031 1.35239 8.18626 1.38713C8.24222 1.42187 8.28735 1.47155 8.31656 1.53058L9.85656 4.64991C9.95788 4.85533 10.1076 5.03304 10.2928 5.16776C10.4781 5.30247 10.6933 5.39015 10.9199 5.42325L14.3639 5.92725C14.4292 5.9367 14.4905 5.96423 14.5409 6.00671C14.5913 6.0492 14.6288 6.10495 14.6492 6.16765C14.6696 6.23036 14.6721 6.29752 14.6563 6.36154C14.6405 6.42556 14.6071 6.48388 14.5599 6.52991L12.0692 8.95525C11.9048 9.11521 11.7818 9.31279 11.7109 9.53092C11.6399 9.74905 11.6231 9.98117 11.6619 10.2072L12.2499 13.6339C12.2614 13.6991 12.2544 13.7663 12.2296 13.8277C12.2048 13.8891 12.1632 13.9423 12.1096 13.9812C12.056 14.0202 11.9925 14.0432 11.9265 14.0478C11.8604 14.0524 11.7944 14.0384 11.7359 14.0072L8.65723 12.3886C8.45441 12.282 8.2287 12.2262 7.99956 12.2262C7.77042 12.2262 7.54472 12.282 7.3419 12.3886L4.2639 14.0072C4.20545 14.0382 4.1395 14.0521 4.07353 14.0474C4.00757 14.0427 3.94424 14.0196 3.89076 13.9807C3.83728 13.9418 3.79579 13.8887 3.771 13.8274C3.74622 13.7661 3.73914 13.699 3.75056 13.6339L4.3379 10.2079C4.37681 9.98173 4.36006 9.74948 4.28909 9.53122C4.21812 9.31297 4.09506 9.11528 3.93056 8.95525L1.4399 6.53058C1.39229 6.4846 1.35856 6.42618 1.34254 6.36196C1.32652 6.29775 1.32886 6.23033 1.34928 6.16737C1.36971 6.10442 1.40741 6.04847 1.45808 6.0059C1.50876 5.96333 1.57037 5.93585 1.6359 5.92658L5.07923 5.42325C5.30611 5.39036 5.52157 5.30277 5.70706 5.16804C5.89254 5.03332 6.04246 4.8555 6.1439 4.64991L7.68323 1.53058Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_49709_2712">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Most popular
          </div>
        </div>
        <div class="referral-card-body">
          <h2 class="referral-title">
            {{referralPopularData.title}}
          </h2>
          <ul class="referral-bullets">
            <li v-for="(bullet, index) in referralPopularData.bullets" :key="index">{{bullet}}</li>
          </ul>
        </div>
        <div class="referral-card-footer">
          <button :disabled="loading" type="button" class="button" @click="onShare(ReferralShareType.Individual)">
            Share to an Individual Referral
          </button>
        </div>
      </div>

      <div class="dbc-card referral-card quick-boost">
        <div class="referral-card-header">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z"
              fill="#125ECE"
            />
          </svg>
          <span class="referral-type">
            Facebook Share
          </span>

          <div class="referral-card-label">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.6139 4.41333C14.5463 4.25043 14.4168 4.12098 14.2539 4.05333C14.1738 4.01917 14.0877 4.00105 14.0006 4H10.6673C10.4905 4 10.3209 4.07024 10.1959 4.19526C10.0708 4.32029 10.0006 4.48986 10.0006 4.66667C10.0006 4.84348 10.0708 5.01305 10.1959 5.13807C10.3209 5.2631 10.4905 5.33333 10.6673 5.33333H12.3939L8.66728 9.06L6.47394 6.86C6.41197 6.79751 6.33823 6.74792 6.25699 6.71407C6.17576 6.68023 6.08862 6.6628 6.00061 6.6628C5.9126 6.6628 5.82547 6.68023 5.74423 6.71407C5.66299 6.74792 5.58925 6.79751 5.52728 6.86L1.52728 10.86C1.46479 10.922 1.4152 10.9957 1.38135 11.0769C1.3475 11.1582 1.33008 11.2453 1.33008 11.3333C1.33008 11.4213 1.3475 11.5085 1.38135 11.5897C1.4152 11.671 1.46479 11.7447 1.52728 11.8067C1.58925 11.8692 1.66299 11.9187 1.74423 11.9526C1.82547 11.9864 1.9126 12.0039 2.00061 12.0039C2.08862 12.0039 2.17576 11.9864 2.25699 11.9526C2.33823 11.9187 2.41197 11.8692 2.47394 11.8067L6.00061 8.27333L8.19394 10.4733C8.25592 10.5358 8.32965 10.5854 8.41089 10.6193C8.49213 10.6531 8.57927 10.6705 8.66728 10.6705C8.75528 10.6705 8.84242 10.6531 8.92366 10.6193C9.0049 10.5854 9.07863 10.5358 9.14061 10.4733L13.3339 6.27333V8C13.3339 8.17681 13.4042 8.34638 13.5292 8.47141C13.6542 8.59643 13.8238 8.66667 14.0006 8.66667C14.1774 8.66667 14.347 8.59643 14.472 8.47141C14.597 8.34638 14.6673 8.17681 14.6673 8V4.66667C14.6662 4.57955 14.6481 4.49348 14.6139 4.41333Z"
                fill="white"
              />
            </svg>
            Quick boost
          </div>
        </div>
        <div class="referral-card-body">
          <h2 class="referral-title">
            Boost your referrals
          </h2>
          <ul class="referral-bullets">
            <li>Reach your entire network at once</li>
            <li>Automatic tracking when friends shop</li>
            <li>Use the power of social media to generate referrals</li>
          </ul>
        </div>
        <div class="referral-card-footer">
          <button :disabled="loading" type="button" class="button" @click="onShare(ReferralShareType.Facebook)">Share to Facebook</button>
        </div>
      </div>

      <div class="info-text">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.96732 12.0007C8.20065 12.0007 8.39799 11.92 8.55932 11.7587C8.72065 11.5973 8.8011 11.4002 8.80065 11.1673C8.80021 10.9344 8.71976 10.7371 8.55932 10.5753C8.39887 10.4135 8.20154 10.3331 7.96732 10.334C7.7331 10.3349 7.53598 10.4155 7.37599 10.576C7.21598 10.7364 7.13532 10.9335 7.13399 11.1673C7.13265 11.4011 7.21332 11.5984 7.37599 11.7593C7.53865 11.9202 7.73576 12.0007 7.96732 12.0007ZM7.36732 9.43399H8.60065C8.60065 9.06732 8.64243 8.77843 8.72599 8.56732C8.80954 8.35621 9.04554 8.06732 9.43398 7.70065C9.72287 7.41177 9.95065 7.13665 10.1173 6.87532C10.284 6.61399 10.3673 6.30021 10.3673 5.93399C10.3673 5.31177 10.1395 4.83399 9.68398 4.50065C9.22843 4.16732 8.68954 4.00065 8.06732 4.00065C7.43399 4.00065 6.92021 4.16732 6.52599 4.50065C6.13176 4.83399 5.85665 5.23399 5.70065 5.70065L6.80065 6.13399C6.85621 5.93399 6.98132 5.71732 7.17598 5.48399C7.37065 5.25065 7.66776 5.13399 8.06732 5.13399C8.42287 5.13399 8.68954 5.23132 8.86732 5.42599C9.0451 5.62065 9.13399 5.83443 9.13399 6.06732C9.13399 6.28954 9.06732 6.49799 8.93398 6.69265C8.80065 6.88732 8.63399 7.06777 8.43398 7.23399C7.9451 7.66732 7.6451 7.9951 7.53399 8.21732C7.42287 8.43954 7.36732 8.8451 7.36732 9.43399ZM8.00065 14.6673C7.07843 14.6673 6.21176 14.4924 5.40065 14.1427C4.58954 13.7929 3.88399 13.3178 3.28399 12.7173C2.68399 12.1169 2.2091 11.4113 1.85932 10.6007C1.50954 9.78999 1.33443 8.92332 1.33399 8.00065C1.33354 7.07799 1.50865 6.21132 1.85932 5.40065C2.20999 4.58999 2.68487 3.88443 3.28399 3.28399C3.8831 2.68354 4.58865 2.20865 5.40065 1.85932C6.21265 1.50999 7.07932 1.33488 8.00065 1.33399C8.92199 1.3331 9.78865 1.50821 10.6007 1.85932C11.4127 2.21043 12.1182 2.68532 12.7173 3.28399C13.3164 3.88265 13.7915 4.58821 14.1427 5.40065C14.4938 6.2131 14.6687 7.07977 14.6673 8.00065C14.666 8.92154 14.4909 9.78821 14.142 10.6007C13.7931 11.4131 13.3182 12.1187 12.7173 12.7173C12.1164 13.316 11.4109 13.7911 10.6007 14.1427C9.79043 14.4942 8.92376 14.6691 8.00065 14.6673ZM8.00065 13.334C9.48954 13.334 10.7507 12.8173 11.784 11.784C12.8173 10.7507 13.334 9.48954 13.334 8.00065C13.334 6.51177 12.8173 5.25065 11.784 4.21732C10.7507 3.18399 9.48954 2.66732 8.00065 2.66732C6.51176 2.66732 5.25065 3.18399 4.21732 4.21732C3.18399 5.25065 2.66732 6.51177 2.66732 8.00065C2.66732 9.48954 3.18399 10.7507 4.21732 11.784C5.25065 12.8173 6.51176 13.334 8.00065 13.334Z"
            fill="currentColor"
          />
        </svg>
        Why two options
      </div>

      <div class="info-card">
        <div>
          <strong>Individual referrals</strong> work best for people you know
          personally who are actively looking for a car.
        </div>
        <div>
          <strong>Facebook sharing</strong> casts a wider net and earns you an
          immediate bonus, plus you still get referral rewards if anyone from
          your network makes a purchase.
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import { PAGES } from '@/shared/routes.constants.js'
import { mapState, mapGetters } from 'vuex'
import {ReferralShareType, ReferralProgramType} from '@/shared/enums/referral.enum.js'

export default {
  name: 'referral-main',
  props: ['loading'],
  computed: {
    ...mapState({
      referralsCount: (state) => {
        return state.recommendFriend.historyCount <= 99
          ? state.recommendFriend.historyCount
          : '+99'
      },
      companyName: (state) => state.common.companyName,
      salesPersonFullName: (state) => state.common.salesPersonFullName,
      referralProgramInfo: (state) => state.recommendFriend.mainInfo
    }),
    ...mapGetters({
      historyLoaded: 'recommendFriend/historyLoaded',
      referralProgramType: 'recommendFriend/referralProgramType'
    }),
    title () {
      return `Share ${this.companyName} with your network`
    },
    description () {
      return `Choose how you'd like to refer friends and earn rewards when they purchase from ${this.salesName}`
    },
    salesName () {
      return this.salesPersonFullName.split(' ')[0] // TODO: BE must add the sales first and last name separately instead of full name only
    }
  },
  watch: {
    referralProgramInfo: {
      immediate: true,
      handler (referralData) {
        if (referralData) {
          this.buildReferralPopularCardContent(referralData)
        }
      }
    }
  },
  data () {
    return {
      historyLink: [PAGES.RecommendAFriend, PAGES.Referrals].join('/'),
      ReferralShareType: ReferralShareType,
      referralPopularData: null
    }
  },
  methods: {
    buildReferralPopularCardContent (data) {
      const contentData = {
        [ReferralProgramType.NonMonetary]: {
          title: 'Connect friends with great service',
          bullets: ['Personal recommendations to friends & family', 'Help friends get VIP treatment', 'Build stronger relationships through trust']
        },
        [ReferralProgramType.ReferralAward]: {
          title: `Earn $${data.referralAward} per sale`,
          bullets: ['Personal recommendations to friends & family', `${data.referralAward} bonus for each completed sale`, 'Track your referrals and earnings']
        },
        [ReferralProgramType.GiveAndGet]: {
          title: `Give $${data.giveReward}, Get $${data.referralAward}`,
          bullets: ['Personal recommendations to friends & family', `$${data.referralAward} bonus for each completed sale`, `Friends save $${data.giveReward} on their purchase`]
        }
      }

      this.referralPopularData = contentData[data.referralProgramId]
    },
    onShare (type) {
      this.$emit('share', type)
    }
  }
}
</script>

<style scoped>
section {
  margin-bottom: 32px;
}

.header-link-container {
  position: relative;
}

.header-link-container > .badge {
  position: absolute;
  display: grid;
  place-content: center;
  min-width: 18px;
  height: 18px;
  background-color: rgb(255, 61, 61);
  padding-inline: 4px;
  line-height: 1;
  border-radius: 18px;
  font-size: 14px;
  top: 0px;
  left:100%;
  transform: translateX(-50%);
}

.referral-cards {
  display: grid;
  grid-auto-rows: auto;
  row-gap: 1rem;
}

.referral-card,
.info-card {
  border-radius: 1rem;
  padding: 1rem;
  display: grid;
  grid-auto-rows: auto;
  row-gap: 1rem;
}

.referral-card {
  border: 1px solid rgba(159, 161, 165, 1);
}

.referral-card.popular {
  --accent-color: rgba(55, 166, 16, 1);
  background-color: rgba(55, 166, 16, 0.05);
}

.referral-card.quick-boost {
  --accent-color: rgba(19, 94, 207, 1);
  background-color: rgba(19, 94, 207, 0.05);
}

.referral-card .button {
  background-color: rgba(18, 94, 206, 1);
  color: #fff;
  text-transform: initial;
}

.referral-card-header {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.referral-card-header > svg {
  flex-shrink: 0;
}

.referral-card-header > .referral-type {
  white-space: nowrap;
  flex: 1;
}

.referral-card-label {
  background-color: var(--accent-color, #5f5f5f);
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 28px;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
}

.referral-title {
  color: var(--accent-color);
  font-weight: 700;
  font-size: 22px;
  padding: 0;
}

.referral-bullets {
  list-style: disc;
  padding-left: 1.5rem;
}

.referral-card-footer button {
  margin-inline: auto;
  width: 100%;
}

.info-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1ch;
  color: rgba(19, 94, 207, 1);
  font-weight: 600;
}

.info-card {
  line-height: 1.2;
  background-color: rgba(19, 94, 207, 0.05);
}

</style>




// WEBPACK FOOTER //
// referral-main.vue?7c1a2d6c